import React from 'react';
import PropTypes from 'prop-types';
import { Route, Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { isLoggedInSelector } from '../../redux/reducers/app/params';
import NetworkError from '../../utils/NetworkError';
import { UNAUTHORIZED } from '../../constants/routeTemplates';

const PrivateRoute = ({ children, fallback, ...restProps }) => {
  const isLoggedIn = useSelector(isLoggedInSelector);

  const loginFallback =
    fallback && typeof fallback === 'function' ? (
      fallback(restProps)
    ) : (
      <Redirect
        to={{
          pathname: UNAUTHORIZED,
          state: {
            error: { ...new NetworkError(401) },
          },
        }}
      />
    );

  return (
    <Route
      {...restProps}
      render={() => (isLoggedIn ? children : loginFallback)}
    />
  );
};

PrivateRoute.propTypes = {
  fallback: PropTypes.func,
};

export default PrivateRoute;
